// src/features/SalesPerson/page/Category

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { SalesPersonType } from '../../types/salesPersonType';
import dayjs from 'dayjs';



const SalesPerson = () => {
 

    // Define columns for the Category table
    const CategoryColumns: ColumnsType<SalesPersonType> = [
        { title: "Name", dataIndex: "name", key: "name", sorter: true },
        { title: "Gender", dataIndex: "gender", key: "gender" },
        //{ title: "MaritalStatus", dataIndex: "maritalStatus", key: "maritalStatus" },
        { title: "DOB", dataIndex: "dob", key: "dob", render: (text: string) => (text ? dayjs(text).format('DD-MM-YYYY') : '') },
        { title: "National ID", dataIndex: "nationalIDNo", key: "nationalIDNo" },
        { title: "Passport No", dataIndex: "passportNo", key: "passportNo" },
        { title: "Nationality", dataIndex: "nationality", key: "nationality" },
        { title: "Phone No", dataIndex: "phoneNo", key: "phoneNo" },
        { title: "Mobile No", dataIndex: "mobileNo", key: "mobileNo" },
        { title: "Fax No", dataIndex: "faxNo", key: "faxNo" },
        { title: "Address", dataIndex: "address", key: "address" },
        { title: "PremiumNetAmtPercentage", dataIndex: "premiumNetAmtPercentage", key: "premiumNetAmtPercentage" },
        { title: "PremiumTotalAmtPercentage", dataIndex: "premiumTotalAmtPercentage", key: "premiumTotalAmtPercentage" },

    ];

    return (
        <div>
            <DynamicTable<SalesPersonType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.SALESPERSON.SEARCH_SALESPERSON} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.SALESPERSON.SALESPERSON} // Unique query key for menus
                columns={CategoryColumns}
                tableTitle={"Sales Person"}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.SALESPERSON.DELETE_SALESPERSON}
                deletePayloadField={"name"}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: "Search by Sales Person" },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.SALESPERSON.EXPORT_SALESPERSON,
                            fileName: "SalesPerson",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                              
                                { header: "Name", key: "name" },
                                { header: "Gender", key: "gender" },
                                //{ header: "MaritalStatus", key: "maritalStatus" },
                                { header: "DOB", key: "dob" },
                                {
                                    header: "DOB",
                                    key: "dob",
                                    transform: (date: string) => date ? dayjs(date).format('DD-MM-YYYY') : "-"
                                },
                                { header: "National ID", key: "nationalIDNo" },
                                { header: "Passport No", key: "passportNo" },
                                { header: "Nationality", key: "nationality" },
                                { header: "Phone No", key: "phoneNo" },
                                { header: "Mobile No", key: "phoneNo" },
                                { header: "Fax No", key: "faxNo" },
                                { header: "Address", key: "address" },
                                { header: "PremiumNetAmtPercentage", key: "premiumNetAmtPercentage" },
                                { header: "PremiumTotalAmtPercentage", key: "premiumTotalAmtPercentage" }
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default SalesPerson;